/* NaturaVital — Port Maqueta (pm) — real Shopify cart AJAX + hero wheel + pack + PDP */
(function(){
"use strict";
var money=function(c){return "$"+(c/100).toFixed(2);};
var cart=null;
function toast(msg){var t=document.querySelector("[data-pm-toast]");if(!t)return;t.textContent=msg;t.classList.add("on");clearTimeout(t._h);t._h=setTimeout(function(){t.classList.remove("on");},2600);}
function openDrawer(){var d=document.querySelector("[data-pm-drawer]"),s=document.querySelector("[data-pm-scrim]");if(d)d.classList.add("on");if(s)s.classList.add("on");}
function closeDrawer(){var d=document.querySelector("[data-pm-drawer]"),s=document.querySelector("[data-pm-scrim]");if(d)d.classList.remove("on");if(s)s.classList.remove("on");}
function fetchCart(){return fetch("/cart.js",{headers:{"Accept":"application/json"}}).then(function(r){return r.json();});}
function renderCart(){
  if(!cart)return;
  document.querySelectorAll("[data-pm-cart-count]").forEach(function(el){el.textContent=cart.item_count;});
  var box=document.querySelector("[data-pm-drawer-lines]");
  if(box){
    if(!cart.items.length){box.innerHTML='<p class="pm-empty">Your cart is empty — for now.</p>';}
    else{box.innerHTML=cart.items.map(function(it){
      return '<div class="pm-line">'+(it.image?'<img src="'+it.image+'" alt="">':'<span></span>')+
      '<div><b>'+it.product_title+'</b>'+(it.variant_title&&it.variant_title!=="Default Title"?'<span class="var">'+it.variant_title+'</span>':'')+
      '<div class="pm-stepper"><button type="button" data-pm-line-dec="'+it.key+'" aria-label="Decrease">−</button><span class="q">'+it.quantity+'</span><button type="button" data-pm-line-inc="'+it.key+'" aria-label="Increase">+</button></div>'+
      '<button type="button" class="rm" data-pm-line-rm="'+it.key+'">Remove</button></div>'+
      '<b>'+money(it.final_line_price)+'</b></div>';
    }).join("");}
  }
  var sub=document.querySelector("[data-pm-drawer-subtotal]");if(sub)sub.textContent=money(cart.total_price);
  renderPack();
}
var pmTierMins=[3,5,7],pmTierRates={3:5,5:10,7:15},pmLastTier=-1,pmLastCount=-1;
function pmBump(el){if(!el)return;el.classList.remove("is-bump");void el.offsetWidth;el.classList.add("is-bump");}
function pmHit(el,cls){if(!el)return;el.classList.remove(cls);void el.offsetWidth;el.classList.add(cls);}
/* progress fill by segments (Sugarpapi spec): the track is split into one
   segment per tier, tier i's mark sits at (i+.5)/3 of the track, and the
   fill interpolates linearly between marks by item count; full at 7+. */
function pmFillFor(n){
  if(n>=7)return 1;
  var pos=function(i){return (i+.5)/3;};
  var i=-1;pmTierMins.forEach(function(m,k){if(n>=m)i=k;});
  if(i===-1)return Math.min(pos(0),(n/3)*pos(0));
  var a=pmTierMins[i],b=pmTierMins[i+1];
  return pos(i)+((n-a)/(b-a))*(pos(i+1)-pos(i));
}
function pmCardFeedback(card,txt,menos){
  if(!card)return;
  card.classList.remove("is-pop");void card.offsetWidth;card.classList.add("is-pop");
  var b=card.querySelector("[data-pm-mas1]");
  if(b){b.textContent=txt;b.classList.toggle("menos",!!menos);b.classList.remove("show");void b.offsetWidth;b.classList.add("show");}
  setTimeout(function(){card.classList.remove("is-pop");if(b)b.classList.remove("show");},900);
}
function renderPack(){
  var panel=document.querySelector("[data-pm-pack]");if(!panel||!cart)return;
  var qtyByVariant={};
  cart.items.forEach(function(it){qtyByVariant[it.variant_id]=(qtyByVariant[it.variant_id]||0)+it.quantity;});
  document.querySelectorAll("[data-pm-pack-item]").forEach(function(el){
    var q=qtyByVariant[el.getAttribute("data-pm-pack-item")]||0;
    var qEl=el.querySelector("[data-pm-pack-qty]");
    if(qEl){if(el._q!==undefined&&el._q!==q)pmBump(qEl);qEl.textContent=q;}
    el._q=q;el.classList.toggle("in-pack",q>0);
  });
  var n=cart.item_count;
  var rate=n>=7?15:(n>=5?10:(n>=3?5:0));
  var tierIdx=n>=7?2:(n>=5?1:(n>=3?0:-1));
  panel.querySelectorAll("[data-pm-tier]").forEach(function(t){
    t.classList.toggle("on",n>=parseInt(t.getAttribute("data-pm-tier"),10));
  });
  panel.querySelectorAll("[data-pm-dot]").forEach(function(d){
    d.classList.toggle("on",n>=parseInt(d.getAttribute("data-pm-dot"),10));
  });
  panel.querySelectorAll("[data-pm-lab]").forEach(function(l){
    l.classList.toggle("on",n>=parseInt(l.getAttribute("data-pm-lab"),10));
  });
  /* tier-unlock celebration (Sugarpapi moments): dot ring pulse, tier chip
     pop, panel ring pulse and a shine sweep across the CTA — fired when the
     highest reached tier rises, including the first render with items. */
  if(tierIdx>pmLastTier&&(pmLastTier!==-1||n>0)){
    pmHit(panel.querySelector('[data-pm-dot="'+pmTierMins[tierIdx]+'"]'),"hit");
    pmHit(panel.querySelector('[data-pm-tier="'+pmTierMins[tierIdx]+'"]'),"hit");
    pmHit(panel.querySelector(".pm-pack-panel"),"is-hit");
    var ctaBtn=panel.querySelector(".pm-pack-cta");
    if(ctaBtn){ctaBtn.classList.remove("is-shine");void ctaBtn.offsetWidth;ctaBtn.classList.add("is-shine");}
  }
  pmLastTier=tierIdx;
  var fill=panel.querySelector("[data-pm-pack-fill]");if(fill)fill.style.transform="scaleX("+pmFillFor(n)+")";
  var cNum=panel.querySelector("[data-pm-pack-count]");
  if(cNum){if(pmLastCount!==-1&&pmLastCount!==n)pmBump(cNum);cNum.textContent=n;}
  var cTxt=panel.querySelector("[data-pm-pack-count-text]");
  if(cTxt)cTxt.textContent=n===0?"Your pack is empty":(n===1?"1 item in your pack":n+" items in your pack");
  pmLastCount=n;
  var hint=panel.querySelector("[data-pm-pack-hint]");
  if(hint){var nxt=pmTierMins.find(function(t){return t>n;});
    hint.textContent=n===0?"Add 3 items to unlock 5% off":(rate===15?"Top tier unlocked — 15% off at checkout":("Add "+(nxt-n)+" more to unlock "+pmTierRates[nxt]+"% off"));
    hint.classList.toggle("is-max",rate===15);}
  /* Totals base: items_subtotal_price is the sum of line prices BEFORE any
     discount; cart.total_price already has Shopify's automatic pack discount
     applied, so basing the estimate on it would double-count the discount. */
  var base=(typeof cart.items_subtotal_price==="number")?cart.items_subtotal_price:cart.total_price;
  var discAmt=Math.round(base*rate/100);
  var sub=panel.querySelector("[data-pm-pack-subtotal]");if(sub)sub.textContent=money(base);
  var disc=panel.querySelector("[data-pm-pack-discount]");if(disc)disc.textContent=rate?"−"+money(discAmt)+" ("+rate+"%)":"−$0.00";
  var tot=panel.querySelector("[data-pm-pack-total]");if(tot)tot.textContent=money(base-discAmt);
  var cs=panel.querySelector("[data-pm-pack-cta-save]");if(cs)cs.textContent=rate?"You save "+money(discAmt)+" at checkout":"";
  var ship=panel.querySelector("[data-pm-pack-ship]");if(ship)ship.textContent=n>=3?"Free shipping unlocked — 3+ items in your pack.":"Free shipping unlocks at 3+ items in your pack.";
}
function refreshCart(open){return fetchCart().then(function(c){cart=c;renderCart();if(open)openDrawer();});}
function addVariant(id,qty,plan){var item={id:id,quantity:qty||1};if(plan)item.selling_plan=plan;return fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({items:[item]})}).then(function(r){if(!r.ok)throw new Error("add failed");return r.json();});}
function changeLine(key,qty){return fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(function(c){cart=c;renderCart();});}
document.addEventListener("click",function(e){
  var t;
  if(e.target.closest("[data-pm-cart-open]")){openDrawer();return;}
  if(e.target.closest("[data-pm-cart-close]")||e.target.hasAttribute("data-pm-scrim")){closeDrawer();return;}
  t=e.target.closest("[data-pm-add]");
  if(t){var id=parseInt(t.getAttribute("data-pm-add"),10);var qty=parseInt(t.getAttribute("data-pm-qty"),10);if(!(qty>0))qty=1;var root=t.closest("[data-pm-pdp]");var planEl=root?root.querySelector("[data-pm-plan]"):null;var plan=planEl&&planEl.value?parseInt(planEl.value,10):null;t.disabled=true;addVariant(id,qty,plan).then(function(){return refreshCart(true);}).then(function(){toast("Added to your cart");}).catch(function(){toast("Could not add — try again");}).finally(function(){t.disabled=false;});return;}
  t=e.target.closest("[data-pm-line-inc]");if(t){var k=t.getAttribute("data-pm-line-inc");var it=cart.items.find(function(i){return i.key===k;});if(it)changeLine(k,it.quantity+1);return;}
  t=e.target.closest("[data-pm-line-dec]");if(t){var k2=t.getAttribute("data-pm-line-dec");var it2=cart.items.find(function(i){return i.key===k2;});if(it2)changeLine(k2,it2.quantity-1);return;}
  t=e.target.closest("[data-pm-line-rm]");if(t){changeLine(t.getAttribute("data-pm-line-rm"),0);return;}
  t=e.target.closest("[data-pm-pack-plus]");if(t){var pCard=t.closest("[data-pm-pack-item]");addVariant(parseInt(t.getAttribute("data-pm-pack-plus"),10),1).then(function(){return refreshCart(false);}).then(function(){toast("Added to your pack");pmCardFeedback(pCard,"+1",false);});return;}
  t=e.target.closest("[data-pm-pack-minus]");
  if(t){var vid=parseInt(t.getAttribute("data-pm-pack-minus"),10);var mCard=t.closest("[data-pm-pack-item]");var line=cart&&cart.items.find(function(i){return i.variant_id===vid;});if(line)changeLine(line.key,line.quantity-1).then(function(){pmCardFeedback(mCard,"\u22121",true);});return;}
  t=e.target.closest("[data-pm-tab]");
  if(t){var wrap=t.closest("[data-pm-tabs-wrap]");wrap.querySelectorAll("[data-pm-tab]").forEach(function(b){b.classList.toggle("on",b===t);});wrap.querySelectorAll("[data-pm-panel]").forEach(function(p){p.hidden=p.getAttribute("data-pm-panel")!==t.getAttribute("data-pm-tab");});return;}
});
document.addEventListener("keydown",function(e){if(e.key==="Escape")closeDrawer();});
document.addEventListener("pointerdown",function(e){var b=e.target.closest(".pm-pack-cta");if(!b)return;var r=b.getBoundingClientRect();b.style.setProperty("--pm-rx",(e.clientX-r.left)+"px");b.style.setProperty("--pm-ry",(e.clientY-r.top)+"px");b.classList.remove("is-clicked");void b.offsetWidth;b.classList.add("is-clicked");});
refreshCart(false);

/* ---------- Showcase + prod-nav: synced with the hero (maqueta behaviour) ---------- */
var __pmShowSync=null;
document.querySelectorAll("[data-pm-showcase]").forEach(function(sec){
  var dataEl=sec.querySelector("[data-pm-show-data]");if(!dataEl)return;
  var S;try{S=JSON.parse(dataEl.textContent);}catch(e){return;}
  if(!S.length)return;
  var band=document.querySelector("[data-pm-prodnav]");
  var pnBtns=[].slice.call(document.querySelectorAll("[data-pm-pn]"));
  var pnLabel=document.querySelector("[data-pm-pn-label]");
  var card=sec.querySelector("[data-pm-show-card]"),tag=sec.querySelector("[data-pm-show-tag]"),title=sec.querySelector("[data-pm-show-title]"),
      ben=sec.querySelector("[data-pm-show-benefits]"),desc=sec.querySelector("[data-pm-show-desc]"),
      priceEl=sec.querySelector("[data-pm-show-price]"),perEl=sec.querySelector("[data-pm-show-per]"),
      qtyOut=sec.querySelector("[data-pm-show-qty]"),buyA=sec.querySelector("[data-pm-show-buy]"),viewA=sec.querySelector("[data-pm-show-view]"),
      img=sec.querySelector("[data-pm-show-img]"),facts=sec.querySelector("[data-pm-show-facts]"),sparkLayer=sec.querySelector("[data-pm-show-sparks]");
  var qty=1,cur=-1;
  function setQty(q){qty=Math.max(1,Math.min(9,q));if(qtyOut)qtyOut.textContent=qty;if(cur>=0&&buyA)buyA.setAttribute("href",S[cur].buy+qty);}
  var minusB=sec.querySelector("[data-pm-show-minus]"),plusB=sec.querySelector("[data-pm-show-plus]");
  if(minusB)minusB.addEventListener("click",function(){setQty(qty-1);});
  if(plusB)plusB.addEventListener("click",function(){setQty(qty+1);});
  function syncShow(i){
    if(!S[i])return;cur=i;var p=S[i];
    if(band)band.style.background=p.bg;
    pnBtns.forEach(function(b,bi){b.classList.toggle("on",bi===i);});
    if(pnLabel)pnLabel.textContent=p.name+" \u2014 "+money(p.price);
    sec.style.background=p.bg;
    if(card){card.style.background=p.color;card.style.setProperty("--pm-deep",p.deep);}
    if(buyA){buyA.style.backgroundColor="#fff";buyA.style.color=p.deep;}
    if(tag)tag.textContent=p.tag||"NaturaVital";
    if(title)title.innerHTML=p.name.replace(" ","<br>");
    if(ben)ben.innerHTML=p.benefits||"";
    if(desc)desc.textContent=p.desc||"";
    if(priceEl)priceEl.innerHTML=(p.was?"<s>"+money(p.was)+"</s>":"")+money(p.price);
    if(perEl)perEl.textContent=p.tagline||p.name;
    if(img){img.src=p.img;img.alt=p.name+" \u2014 real product photo";}
    if(sparkLayer)sparkLayer.style.setProperty("--pspark",p.spark||"#FFFFFF");
    if(facts){var rows=[["Price",money(p.price)+(p.was?" \u00b7 was "+money(p.was):"")],["Format",p.tagline||"Full size"],["Shipping","Free over $49 \u00b7 else $6.90"],["Returns","15 days \u00b7 no restocking fee"]];
      facts.innerHTML=rows.map(function(f){return '<div class="pm-fact" style="--fc:'+p.color+';--fd:'+p.deep+'"><b>'+f[0]+'</b><span>'+f[1]+'</span></div>';}).join("");}
    if(viewA)viewA.setAttribute("href",p.url);
    setQty(1);
  }
  pnBtns.forEach(function(b){b.addEventListener("click",function(){var i=parseInt(b.getAttribute("data-pm-pn"),10);if(window.__pmHeroGo)window.__pmHeroGo(i);syncShow(i);sec.scrollIntoView({behavior:"smooth"});});});
  __pmShowSync=syncShow;
  syncShow(0);
  /* showcase sparkles \u2014 dots fly from the product silhouette out to the halo edge */
  var reducedS=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var sparkTimer=null,hovering=false,inView=false;
  function spawnSpark(){
    if(reducedS||!sparkLayer||!img||!img.animate)return;
    var halo=sec.querySelector(".pm-show-halo");if(!halo)return;
    var lr=sparkLayer.getBoundingClientRect(),hr=halo.getBoundingClientRect();
    if(!hr.width)return;
    var cx=hr.left+hr.width/2-lr.left,cy=hr.top+hr.height/2-lr.top,haloR=hr.width/2;
    var ir=img.getBoundingClientRect();if(!ir.width)return;
    var jcx=ir.left+ir.width/2-lr.left,jcy=ir.top+ir.height/2-lr.top;
    var rx=ir.width*0.46,ry=ir.height*0.46;
    var ang=Math.random()*Math.PI*2,dx=Math.cos(ang),dy=Math.sin(ang);
    var t=1/Math.sqrt((dx/rx)*(dx/rx)+(dy/ry)*(dy/ry));
    var sx=jcx+dx*t,sy=jcy+dy*t;
    var vx=sx-cx,vy=sy-cy,vl=Math.sqrt(vx*vx+vy*vy)||1;
    var ex=cx+(vx/vl)*(haloR+8),ey=cy+(vy/vl)*(haloR+8);
    var sp=document.createElement("span");sp.className="pm-show-spark";
    var sz=(6+Math.random()*7).toFixed(1);sp.style.width=sz+"px";sp.style.height=sz+"px";
    sparkLayer.appendChild(sp);
    var dur=850+Math.random()*450;
    var anim=sp.animate([{transform:"translate("+sx.toFixed(1)+"px,"+sy.toFixed(1)+"px) translate(-50%,-50%) scale(.5)",opacity:0},{opacity:1,offset:0.14},{opacity:0.95,offset:0.62},{transform:"translate("+ex.toFixed(1)+"px,"+ey.toFixed(1)+"px) translate(-50%,-50%) scale(1.05)",opacity:0}],{duration:dur,easing:"cubic-bezier(.16,.84,.44,1)",fill:"forwards"});
    anim.onfinish=function(){sp.remove();};
    setTimeout(function(){if(sp.parentNode)sp.remove();},dur+900);
  }
  function sparkLoop(){clearInterval(sparkTimer);sparkTimer=null;if(reducedS||!inView)return;spawnSpark();sparkTimer=setInterval(spawnSpark,hovering?90:210);}
  if("IntersectionObserver" in window){new IntersectionObserver(function(en){inView=en[0].isIntersecting;sparkLoop();},{rootMargin:"240px"}).observe(img);}else{inView=true;sparkLoop();}
  img.addEventListener("mouseenter",function(){hovering=true;sparkLoop();});
  img.addEventListener("mouseleave",function(){hovering=false;sparkLoop();});
});

/* ---------- Hero: arc wheel ported from the maqueta ---------- */
window.__pmHeroGo=null;
document.querySelectorAll("[data-pm-hero]").forEach(function(hero){
  var stage=hero.querySelector("[data-pm-stage]");if(!stage)return;
  var jars=[].slice.call(hero.querySelectorAll("[data-pm-jar]"));var N=jars.length;if(!N)return;
  var blob=hero.querySelector("[data-pm-blob]"),ringWrap=hero.querySelector("[data-pm-ring-wrap]"),
      sparkLayer=hero.querySelector("[data-pm-sparkles]"),tooltip=hero.querySelector("[data-pm-tooltip]"),
      nameEl=hero.querySelector("[data-pm-hc-name]"),metaEl=hero.querySelector("[data-pm-hc-meta]"),
      buyEl=hero.querySelector("[data-pm-hc-buy]"),viewEl=hero.querySelector("[data-pm-hc-view]"),
      counter=hero.querySelector("[data-pm-counter]"),fill=hero.querySelector("[data-pm-progress-fill]"),
      dots=[].slice.call(hero.querySelectorAll("[data-pm-dot]"));
  var reduced=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var data=jars.map(function(j){return {url:j.getAttribute("data-url"),buy:j.getAttribute("data-buy"),name:j.getAttribute("data-name"),tagline:j.getAttribute("data-tagline")||"",price:parseInt(j.getAttribute("data-price"),10),was:j.getAttribute("data-was")?parseInt(j.getAttribute("data-was"),10):null,color:j.getAttribute("data-color")};});
  var pos=0,posTarget=0,activeIdx=-1,spacing=300,curveY=30;
  var dragging=false,dragMoved=false,dragStartX=0,dragStartPos=0,snapTimer=null;
  var ringAngle=0,prevPos=0;
  var hover=false,autoTimer=0,lastT=performance.now();
  hero.addEventListener("pointerenter",function(){hover=true;});
  hero.addEventListener("pointerleave",function(){hover=false;});
  function measure(){var w=stage.clientWidth;/* fidelity pass 2: desktop spacing tightened (was 0.46w, cap 700) so all five jars sit on stage at rest, as rendered in the maqueta; mobile formula unchanged */
    spacing=w<640?Math.max(290,w*0.78):Math.max(220,Math.min(w*0.22,420));curveY=w<640?18:30;}
  measure();window.addEventListener("resize",measure);
  function clampPos(v){return Math.max(0,Math.min(N-1,v));}
  /* wrap-around arc (owner fix): relative distance is always taken modulo
     N, so all five jars stay on stage at every stop, first and last included.
     pos/posTarget may travel past the ends; rendering is modulo N and the
     settled position is normalised back into range invisibly. */
  function relD(i,p){var d=i-p;return d-N*Math.round(d/N);}
  function normIdx(i){return ((i%N)+N)%N;}
  function goTo(i){autoTimer=0;var base=Math.round(posTarget);posTarget=i+N*Math.round((base-i)/N);}
  function stepHero(dir){autoTimer=0;posTarget=Math.round(posTarget)+dir;}
  window.__pmHeroGo=goTo;
  function snap(){autoTimer=0;posTarget=Math.round(posTarget);}
  if(!reduced&&sparkLayer){
    var sparkCount=window.innerWidth<640?30:56;
    for(var s=0;s<sparkCount;s++){
      var sp=document.createElement("span");sp.className="pm-sparkle";
      sp.style.setProperty("--ang",(Math.random()*360).toFixed(1)+"deg");
      sp.style.setProperty("--dist",(110+Math.random()*230).toFixed(0)+"px");
      sp.style.setProperty("--sweep",(14+Math.random()*26).toFixed(1)+"deg");
      sp.style.setProperty("--sz",(5+Math.random()*7).toFixed(1)+"px");
      sp.style.setProperty("--dur",(4.6+Math.random()*4.2).toFixed(2)+"s");
      sp.style.setProperty("--dl",(-Math.random()*9).toFixed(2)+"s");
      sparkLayer.appendChild(sp);
    }
  }
  function burstSparkles(color){
    if(reduced||!sparkLayer)return;
    var count=window.innerWidth<640?30:48;
    for(var b=0;b<count;b++){
      var bp=document.createElement("span");bp.className="pm-sparkle burst";
      bp.style.setProperty("--spark",color);
      bp.style.setProperty("--ang",(Math.random()*360).toFixed(1)+"deg");
      bp.style.setProperty("--dist",(170+Math.random()*300).toFixed(0)+"px");
      bp.style.setProperty("--sweep",(18+Math.random()*40).toFixed(1)+"deg");
      bp.style.setProperty("--sz",(5+Math.random()*8).toFixed(1)+"px");
      bp.style.setProperty("--bdur",(0.8+Math.random()*0.55).toFixed(2)+"s");
      bp.style.setProperty("--bdl",(Math.random()*0.12).toFixed(2)+"s");
      sparkLayer.appendChild(bp);
      (function(node){node.addEventListener("animationend",function(){node.remove();});setTimeout(function(){if(node.parentNode)node.remove();},2400);})(bp);
    }
  }
  if(tooltip){document.addEventListener("mousemove",function(e){tooltip.style.left=e.clientX+"px";tooltip.style.top=e.clientY+"px";});}
  function setActive(i){
    var prevIdx=activeIdx;activeIdx=i;
    var d=data[i];if(!d)return;
    if(blob)blob.style.backgroundColor=d.color;
    if(sparkLayer)sparkLayer.style.setProperty("--spark",d.color);
    if(nameEl)nameEl.textContent=d.name;
    if(metaEl)metaEl.innerHTML=(d.tagline?d.tagline+" \u00b7 ":"")+(d.was?"<s>"+money(d.was)+"</s>":"")+"<b>"+money(d.price)+"</b>";
    if(buyEl){buyEl.style.backgroundColor=d.color;buyEl.setAttribute("href",d.buy);}
    if(viewEl)viewEl.setAttribute("href",d.url);
    dots.forEach(function(dt,di){dt.classList.toggle("on",di===i);dt.setAttribute("aria-selected",di===i?"true":"false");});
    if(counter)counter.textContent="0"+(i+1)+" / 0"+N;
    if(prevIdx!==-1&&prevIdx!==i)burstSparkles(d.color);
    if(__pmShowSync)__pmShowSync(i);
  }
  var startTime=performance.now();
  function layout(now){
    var t=(now-startTime)/1000;
    var dt=Math.min(50,now-lastT);lastT=now;
    /* verified discrete auto-advance: exactly one step every 4.5 s, then fully settled */
    if(!dragging&&!hover&&!document.hidden&&Math.abs(posTarget-pos)<0.001){
      autoTimer+=dt;
      if(autoTimer>=4500){autoTimer=0;posTarget=Math.round(posTarget)+1;}
    }else if(Math.abs(posTarget-pos)>=0.001){autoTimer=0;}
    pos+=(posTarget-pos)*(reduced?1:0.082);
    if(Math.abs(posTarget-pos)<0.0004){pos=posTarget;
      var sh=N*Math.round(pos/N);if(sh){pos-=sh;posTarget-=sh;prevPos-=sh;}}
    ringAngle+=(pos-prevPos)*22;prevPos=pos;
    jars.forEach(function(el,i){
      var d=relD(i,pos),ad=Math.abs(d);
      var bob=reduced?0:Math.sin(t*1.15+i*1.7)*8*Math.max(0,1-ad*0.3);
      var x=d*spacing;
      var y=Math.pow(ad,1.7)*curveY+bob;
      var rot=d*10;
      var sc=1-Math.min(ad,2.4)*0.16;
      var op=ad>2.45?Math.max(0,1-(ad-2.45)*2.4):1;
      el.style.transform="translate(-50%,-50%) translate("+x.toFixed(1)+"px,"+y.toFixed(1)+"px) rotate("+rot.toFixed(2)+"deg) scale("+sc.toFixed(3)+")";
      el.style.zIndex=String(30-Math.round(ad*5));
      el.style.opacity=op.toFixed(2);
      el.style.pointerEvents=ad>2.6?"none":"auto";
      var rotRad=Math.abs(rot)*Math.PI/180;
      var halfBox=(el.offsetWidth*Math.cos(rotRad)+el.offsetHeight*Math.sin(rotRad))*sc/2;
      var offStage=ad>1.8||Math.abs(x)+halfBox>stage.clientWidth/2+2;
      if(el._offStage!==offStage){el._offStage=offStage;el.inert=offStage;if(offStage)el.setAttribute("aria-hidden","true");else el.removeAttribute("aria-hidden");}
    });
    if(ringWrap)ringWrap.style.transform="translate(-50%,-50%) rotate("+ringAngle.toFixed(2)+"deg)";
    if(fill){var posN=pos-N*Math.floor(pos/N);fill.style.width=(N>1?Math.max(0,Math.min(100,(posN/(N-1))*100)):100)+"%";}
    var idx=normIdx(Math.round(pos));
    if(idx!==activeIdx)setActive(idx);
    requestAnimationFrame(layout);
  }
  /* Mouse-wheel stepping (owner: "hago scroll con el mouse y no cambian
     los productos como teniamos antes" + "el scroll funciona pero baja la
     pagina a la misma vez por lo cual no se pueden ver todos los
     productos al scrolear"). The DOMINANT axis of the gesture drives the
     carousel: wheel down/right = next jar, up/left = previous, exactly
     one step per gesture through stepHero (same discrete settle as the
     arrows, auto-timer reset included). Gesture totals PERSIST across
     pauses (persistence note by the handler below), so one flick can
     never chain steps and noisy trackpad micro-events accumulate
     toward a single step; deltaMode is normalised (line x16, page x
     viewport height), so one mouse notch (~100) always passes the 40
     threshold.
     TOTAL preventDefault inside the reading position: a smooth wheel
     emits a STREAM of small events, and swallowing only the one event
     that fires the step still let every other event of the gesture
     (the ones accumulating toward the threshold and the ones arriving
     during the lock) scroll the page — the product changed AND the page
     drifted down, so the hero left its reading position after 1-2 jars
     and the rest could not be reached by scrolling. Now, while the
     pointer is over the hero AND heroInRead() holds, EVERY wheel event
     is preventDefaulted — the accumulating ones, the locked ones and
     the inertia tail — so window.scrollY cannot move at all while the
     user walks 01->02->03->04->05 by scrolling, gesture after gesture.
     Two hard rules still keep the page free:
     (1) NO WRAP on the wheel path: at the LAST slide a gesture pointing
         forward, and at the FIRST slide one pointing backward (the
         event's own dominant direction decides), are NOT intercepted
         (no preventDefault, no step) — that gesture and the following
         ones scroll the page as normal. Arrows, dots and the 4.5 s
         auto-advance still wrap as before.
     (2) Interception only in the hero's reading position (heroInRead):
         its top edge has not scrolled more than a quarter of its own
         height above the viewport top AND its bottom edge still reaches
         the viewport midpoint. Once the hero is half out of view no
         event is preventDefaulted and the wheel belongs to the page. */
  /* Accumulator persistence (follow-up fix): the old 180 ms silence
     reset also killed SLOW accumulation — a smooth wheel or trackpad
     emitting tiny chained impulses (0.02-0.03 viewport each) with
     short pauses between groups never reached the threshold of 40,
     because every pause zeroed the sums. The sums now PERSIST across
     silences and reset only when (a) a step fires, (b) the input
     reverses sign on an axis — that axis restarts from the reversing
     event, so accumulation begins in the new sense — or (c) the
     pointer leaves the hero or the hero leaves its reading position.
     Silence now controls ONLY the post-step lockout: after a step,
     incoming events are still swallowed (preventDefaulted in reading
     position) but NOT accumulated, and the lock lifts only after
     300 ms with no wheel events, a clear pause. The inertia tail of
     the same notch therefore can never build a second step: one notch
     (~100, or 48 in line mode) still yields EXACTLY one step, while
     separate small gestures add up across pauses until they cross 40
     and step once. Threshold unchanged: 40 normalised units. */
  var wheelSumX=0,wheelSumY=0,wheelLock=false,wheelIdle=null;
  function wheelNorm(v,mode){return mode===1?v*16:(mode===2?v*window.innerHeight:v);}
  function heroInRead(){var r=hero.getBoundingClientRect();return r.top>=-0.25*r.height&&r.bottom>=window.innerHeight*0.5;}
  function wheelReset(){wheelSumX=0;wheelSumY=0;wheelLock=false;clearTimeout(wheelIdle);}
  hero.addEventListener("mouseleave",wheelReset);
  hero.addEventListener("wheel",function(e){
    var dx=wheelNorm(e.deltaX,e.deltaMode),dy=wheelNorm(e.deltaY,e.deltaMode);
    if(e.shiftKey&&dx===0){dx=dy;dy=0;}
    /* Every event refreshes the quiet timer, but that timer now only
       releases the post-step lockout (300 ms) — never the sums. */
    clearTimeout(wheelIdle);
    wheelIdle=setTimeout(function(){wheelLock=false;},300);
    if(!heroInRead()){wheelReset();return;}
    var cur=normIdx(Math.round(posTarget));
    /* Release at the ends: this event's own dominant direction points
       out of the range — the gesture belongs to the page. */
    var edir=Math.abs(dy)>=Math.abs(dx)?(dy>0?1:(dy<0?-1:0)):(dx>0?1:(dx<0?-1:0));
    if(!wheelLock&&((edir>0&&cur===N-1)||(edir<0&&cur===0))){wheelSumX=0;wheelSumY=0;return;}
    /* Inside the range, in reading position: swallow the event so the
       page cannot move — accumulating, locked or inertia alike. */
    e.preventDefault();
    if(wheelLock)return;
    /* Sign reversal on an axis restarts that axis from this event:
       pending accumulation in the old sense is discarded. */
    if(dx!==0&&wheelSumX!==0&&((dx>0)!==(wheelSumX>0)))wheelSumX=0;
    if(dy!==0&&wheelSumY!==0&&((dy>0)!==(wheelSumY>0)))wheelSumY=0;
    wheelSumX+=dx;wheelSumY+=dy;
    var adx=Math.abs(wheelSumX),ady=Math.abs(wheelSumY);
    if(Math.max(adx,ady)>=40){
      var wdir=ady>=adx?(wheelSumY>0?1:-1):(wheelSumX>0?1:-1);
      wheelLock=true;wheelSumX=0;wheelSumY=0;
      if((wdir>0&&cur===N-1)||(wdir<0&&cur===0))return;
      stepHero(wdir);
    }
  },{passive:false});
  stage.addEventListener("pointerdown",function(e){dragging=true;dragMoved=false;dragStartX=e.clientX;dragStartPos=posTarget;});
  stage.addEventListener("pointermove",function(e){if(!dragging)return;var dx=e.clientX-dragStartX;if(Math.abs(dx)>6)dragMoved=true;if(dragMoved){autoTimer=0;posTarget=Math.max(dragStartPos-2.6,Math.min(dragStartPos+2.6,dragStartPos-dx/spacing));}});
  function endDrag(){if(!dragging)return;dragging=false;snap();setTimeout(function(){dragMoved=false;},60);}
  stage.addEventListener("pointerup",endDrag);
  stage.addEventListener("pointercancel",endDrag);
  stage.addEventListener("pointerleave",endDrag);
  jars.forEach(function(el,i){
    el.addEventListener("click",function(){if(dragMoved)return;if(Math.abs(relD(i,pos))<0.5){window.location.href=data[i].url;}else goTo(i);});
    el.addEventListener("mouseenter",function(){if(Math.abs(relD(i,pos))<0.5&&tooltip)tooltip.classList.add("on");});
    el.addEventListener("mouseleave",function(){if(tooltip)tooltip.classList.remove("on");});
  });
  var prevB=hero.querySelector("[data-pm-prev]"),nextB=hero.querySelector("[data-pm-next]");
  if(prevB)prevB.addEventListener("click",function(){stepHero(-1);});
  if(nextB)nextB.addEventListener("click",function(){stepHero(1);});
  dots.forEach(function(dt,i){dt.addEventListener("click",function(){goTo(i);});});
  document.addEventListener("keydown",function(e){
    var r=hero.getBoundingClientRect();
    var heroVisible=r.bottom>80&&r.top<window.innerHeight-80;
    if(!heroVisible)return;
    if(e.key==="ArrowRight")stepHero(1);
    if(e.key==="ArrowLeft")stepHero(-1);
  });
  requestAnimationFrame(layout);
});

/* ---------- Newsletter dot cascade ---------- */
document.querySelectorAll("[data-pm-news-cascade]").forEach(function(layer){
  var cols=["#EA580C","#F59E0B","#B0722E","#F49E63","#C7CBD1","#F97316"];
  for(var i=0;i<26;i++){
    var s=document.createElement("span");s.className="pm-news-spark";
    var sz=(4+Math.random()*6).toFixed(1);
    s.style.width=sz+"px";s.style.height=sz+"px";s.style.left=(Math.random()*100)+"%";
    s.style.setProperty("--c",cols[i%cols.length]);
    s.style.setProperty("--dur",(7+Math.random()*6).toFixed(1)+"s");
    s.style.setProperty("--dl",(-Math.random()*10).toFixed(1)+"s");
    s.style.setProperty("--sway",((Math.random()*36)-18).toFixed(0)+"px");
    layer.appendChild(s);
  }
});

/* ---------- Sparkle cascades: shared builder (falling + rising) ---------- */
function pmSparkleCascade(host,layerClass,count,riseEvery){
  if(!host||host.querySelector("."+layerClass))return;
  var layer=document.createElement("div");layer.className=layerClass;layer.setAttribute("aria-hidden","true");
  host.insertBefore(layer,host.firstChild);
  var cols=["#EA580C","#F59E0B","#F49E63","#C7CBD1","#9CA3AF","#F97316"];
  var fi=0,ri=0;
  for(var i=0;i<count;i++){
    var rise=riseEvery>0&&(i%riseEvery===riseEvery-1);
    var n=rise?ri++:fi++;
    var star=(n%4===0);
    var s=document.createElement("span");s.className="pm-pack-fall"+(star?" star":"")+(rise?" rise":"");
    if(star){s.textContent="\u2726";s.style.fontSize=(8+Math.random()*6).toFixed(1)+"px";}
    else{var sz=(3+Math.random()*5).toFixed(1);s.style.width=sz+"px";s.style.height=sz+"px";}
    s.style.left=(Math.random()*100)+"%";
    s.style.setProperty("--c",cols[i%cols.length]);
    s.style.setProperty("--dur",(6+Math.random()*5).toFixed(1)+"s");
    s.style.setProperty("--dl",(-Math.random()*9).toFixed(1)+"s");
    s.style.setProperty("--sway",((Math.random()*30)-15).toFixed(0)+"px");
    layer.appendChild(s);
  }
}
/* Pack panel: sparkles fall inside "Your pack" (all falling, as before) */
document.querySelectorAll(".pm-pack-panel").forEach(function(panelEl){
  pmSparkleCascade(panelEl,"pm-pack-cascade",22,0);
});
/* Cart drawer: sparkles both ways — half fall (top→bottom), half rise (bottom→top) */
document.querySelectorAll(".pm-drawer").forEach(function(drawerEl){
  pmSparkleCascade(drawerEl,"pm-drawer-cascade",24,2);
});

/* ---------- PDP: gallery + variants ---------- */
document.querySelectorAll("[data-pm-pdp]").forEach(function(root){
  var main=root.querySelector("[data-pm-g-main]");
  var thumbs=[].slice.call(root.querySelectorAll("[data-pm-g-thumb]"));
  var idx=0;
  function show(i){if(!thumbs.length)return;idx=((i%thumbs.length)+thumbs.length)%thumbs.length;var th=thumbs[idx];var src=th.getAttribute("data-full");var type=th.getAttribute("data-type");
    if(main){var old=main.querySelector("img,video");if(old)old.remove();
      var el;
      if(type==="video"){el=document.createElement("video");el.src=src;el.controls=true;el.playsInline=true;el.style.cssText="width:100%;height:100%;object-fit:contain";}
      else{el=document.createElement("img");el.src=src;var ti=th.querySelector("img");el.alt=ti?ti.alt:"";}
      main.insertBefore(el,main.firstChild);}
    thumbs.forEach(function(t,j){t.classList.toggle("on",j===idx);});}
  var prev=root.querySelector("[data-pm-g-prev]"),next=root.querySelector("[data-pm-g-next]");
  if(prev)prev.addEventListener("click",function(){show(idx-1);});
  if(next)next.addEventListener("click",function(){show(idx+1);});
  thumbs.forEach(function(t,i){t.addEventListener("click",function(){show(i);});});
  var dataEl=root.querySelector("[data-pm-variants]");
  if(dataEl){
    var variants=JSON.parse(dataEl.textContent);
    var groups=[].slice.call(root.querySelectorAll("[data-pm-opt-group]"));
    var priceEl=root.querySelector("[data-pm-price]"),wasEl=root.querySelector("[data-pm-was]"),saveEl=root.querySelector("[data-pm-save]"),atc=root.querySelector("[data-pm-atc]"),buy=root.querySelector("[data-pm-buy]");
    function selected(){return groups.map(function(g){var b=g.querySelector(".on");return b?b.getAttribute("data-val"):null;});}
    function current(){var sel=selected();return variants.find(function(v){return v.options.every(function(o,i){return sel[i]===null||o===sel[i];});});}
    function update(){
      var v=current();if(!v)return;
      if(priceEl)priceEl.textContent=money(v.price);
      if(wasEl){if(v.compare&&v.compare>v.price){wasEl.textContent=money(v.compare);wasEl.style.display="";}else wasEl.style.display="none";}
      if(saveEl){if(v.compare&&v.compare>v.price){saveEl.textContent="SAVE "+Math.round((v.compare-v.price)*100/v.compare)+"%";saveEl.style.display="";}else saveEl.style.display="none";}
      if(atc){atc.setAttribute("data-pm-add",v.id);atc.disabled=!v.available;atc.textContent=v.available?("Add to Cart — "+money(v.price)):"Sold Out";}
      if(buy)buy.setAttribute("href","/cart/"+v.id+":1");
      groups.forEach(function(g,gi){g.querySelectorAll("[data-val]").forEach(function(b){
        var sel=selected();sel[gi]=b.getAttribute("data-val");
        var exists=variants.some(function(vv){return vv.options.every(function(o,i){return o===sel[i];});});
        b.disabled=!exists;});});
    }
    groups.forEach(function(g){g.addEventListener("click",function(e){var b=e.target.closest("[data-val]");if(!b||b.disabled)return;g.querySelectorAll("[data-val]").forEach(function(x){x.classList.toggle("on",x===b);});var card=b.closest(".pm-pack-opt");if(card){g.querySelectorAll(".pm-pack-opt").forEach(function(x){x.classList.toggle("on",x===card);});}update();});});
    update();
  }
});
})();

/* ---------- Duo (benefits + how): sparkle cascade + reveal on scroll ---------- */
(function(){
  "use strict";
  var reduced=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  document.querySelectorAll("[data-pm-duo-cascade]").forEach(function(layer){
    if(reduced)return;
    var cols=["#EA580C","#F59E0B","#B0722E","#F49E63","#C7CBD1","#F97316"];
    for(var i=0;i<14;i++){
      var star=(i%5===0);
      var s=document.createElement("span");s.className="pm-duo-spark"+(star?" star":"");
      if(star){s.textContent="\u2726";s.style.fontSize=(7+Math.random()*5).toFixed(1)+"px";}
      else{var sz=(3+Math.random()*4).toFixed(1);s.style.width=sz+"px";s.style.height=sz+"px";}
      s.style.left=(Math.random()*100)+"%";
      s.style.setProperty("--c",cols[i%cols.length]);
      s.style.setProperty("--dur",(9+Math.random()*6).toFixed(1)+"s");
      s.style.setProperty("--dl",(-Math.random()*12).toFixed(1)+"s");
      s.style.setProperty("--sway",((Math.random()*24)-12).toFixed(0)+"px");
      layer.appendChild(s);
    }
  });
  var els=[].slice.call(document.querySelectorAll("[data-pm-reveal]"));
  if(!els.length)return;
  if(reduced||!("IntersectionObserver" in window)){els.forEach(function(el){el.classList.add("pm-in");});return;}
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(!en.isIntersecting)return;
      var el=en.target;io.unobserve(el);
      var sibs=[].slice.call(el.parentNode.children).filter(function(c){return c.hasAttribute&&c.hasAttribute("data-pm-reveal");});
      var k=sibs.indexOf(el);if(k>0)el.style.transitionDelay=(k*0.09)+"s";
      el.classList.add("pm-in");
      setTimeout(function(){el.style.transitionDelay="";},800);
    });
  },{threshold:.15,rootMargin:"0px 0px -6% 0px"});
  els.forEach(function(el){io.observe(el);});
})();


/* ---------- See it in action: click a card → video modal (sound + product card) ----------
   The card stays a plain link to the PDP, so without JS nothing changes.
   With JS the click opens the modal instead: the section's single modal is
   filled from the card's data attributes (all rendered by Liquid from the
   product loop — nothing hardcoded here). Add to Cart reuses the global
   [data-pm-add] delegation above: it sets the variant id on the modal button
   and lets that machinery add the item, open the drawer and toast. */
(function(){
  "use strict";
  var modal=document.querySelector("[data-pm-vmodal]");if(!modal)return;
  var video=modal.querySelector("[data-pm-vvideo]"),
      img=modal.querySelector("[data-pm-vimg]"),
      title=modal.querySelector("[data-pm-vtitle]"),
      price=modal.querySelector("[data-pm-vprice]"),
      atc=modal.querySelector("[data-pm-vatc]"),
      view=modal.querySelector("[data-pm-vview]"),
      lastFocus=null;
  function openModal(card){
    var src=card.getAttribute("data-vid");if(!src)return;
    lastFocus=card;
    title.textContent=card.getAttribute("data-vtitle")||"";
    price.textContent=card.getAttribute("data-vprice")||"";
    var im=card.getAttribute("data-vimg");
    if(im){img.src=im;img.alt=card.getAttribute("data-vtitle")||"";img.style.display="";}
    else{img.removeAttribute("src");img.style.display="none";}
    view.setAttribute("href",card.getAttribute("data-vurl")||"#");
    var v=card.getAttribute("data-vvar");
    if(v){atc.setAttribute("data-pm-add",v);atc.disabled=false;atc.textContent="Add to Cart";}
    else{atc.removeAttribute("data-pm-add");atc.disabled=true;atc.textContent="Sold out";}
    if(video.getAttribute("src")!==src)video.src=src;
    video.muted=false;video.loop=true;
    modal.hidden=false;
    document.documentElement.style.overflow="hidden";
    var pr=video.play();if(pr&&pr.catch)pr.catch(function(){video.muted=true;var p2=video.play();if(p2&&p2.catch)p2.catch(function(){});});
    var x=modal.querySelector(".pm-vmodal-x");if(x)x.focus();
  }
  function closeModal(){
    if(modal.hidden)return;
    modal.hidden=true;
    document.documentElement.style.overflow="";
    video.pause();video.removeAttribute("src");video.load();
    if(lastFocus&&lastFocus.focus)lastFocus.focus();
  }
  document.addEventListener("click",function(e){
    var card=e.target.closest("[data-pm-vopen]");
    if(card){e.preventDefault();openModal(card);return;}
    if(e.target.closest("[data-pm-vatc]")){video.pause();return;}
    if(e.target.closest("[data-pm-vclose]"))closeModal();
  });
  document.addEventListener("keydown",function(e){if(e.key==="Escape")closeModal();});
})();

/* ---------- Section sparkle cascades: action / reviews / faq / trust ----------
   Same recipe as the duo filler above (14 subtle sparks, brand tones, stars
   every fifth) — it targets the [data-pm-sec-cascade] layers those sections
   render, and reuses the .pm-duo-spark spans so the styling, keyframes and
   reduced-motion behaviour are identical to benefits/how. */
(function(){
  "use strict";
  var reduced=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if(reduced)return;
  var cols=["#EA580C","#F59E0B","#B0722E","#F49E63","#C7CBD1","#F97316"];
  document.querySelectorAll("[data-pm-sec-cascade]").forEach(function(layer){
    for(var i=0;i<14;i++){
      var star=(i%5===0);
      var s=document.createElement("span");s.className="pm-duo-spark"+(star?" star":"");
      if(star){s.textContent="\u2726";s.style.fontSize=(7+Math.random()*5).toFixed(1)+"px";}
      else{var sz=(3+Math.random()*4).toFixed(1);s.style.width=sz+"px";s.style.height=sz+"px";}
      s.style.left=(Math.random()*100)+"%";
      s.style.setProperty("--c",cols[i%cols.length]);
      s.style.setProperty("--dur",(9+Math.random()*6).toFixed(1)+"s");
      s.style.setProperty("--dl",(-Math.random()*12).toFixed(1)+"s");
      s.style.setProperty("--sway",((Math.random()*24)-12).toFixed(0)+"px");
      layer.appendChild(s);
    }
  });
})();


/* ---------- PDP pack quantity selector (1/3/5/7) ----------
   Packs are quantities of the single variant; the matching automatic
   discount (3+ −5%, 5+ −10%, 7+ −15%) applies at checkout. The selector
   only sets data-pm-qty on the buy buttons (the [data-pm-add] delegation
   above reads it and adds that many units), rewrites the Buy It Now
   permalink with the chosen quantity, and keeps the shown totals in
   sync (ATC label + sticky bar price). Totals come pre-computed from
   Liquid in each option's data-total — nothing is priced here. */
(function(){
  "use strict";
  document.querySelectorAll("[data-pm-pdp]").forEach(function(root){
    var box=root.querySelector("[data-pm-qpacks]");if(!box)return;
    var atc=root.querySelector("[data-pm-atc]"),buy=root.querySelector("[data-pm-buy]");
    var opts=[].slice.call(box.querySelectorAll("[data-pm-qpack]"));
    if(!opts.length)return;
    var sticky=root.querySelector(".pm-stickybuy"),
        stickyPrice=sticky?sticky.querySelector(".pm-stickybuy-txt span"):null,
        stickyAtc=sticky?sticky.querySelector("[data-pm-add]"):null,
        finalAtc=root.querySelector("[data-pm-final-atc]");
    function apply(btn){
      opts.forEach(function(b){var on=b===btn;b.classList.toggle("on",on);b.setAttribute("aria-checked",on?"true":"false");});
      var qty=parseInt(btn.getAttribute("data-qty"),10);if(!(qty>0))qty=1;
      var total=btn.getAttribute("data-total");
      if(atc){atc.setAttribute("data-pm-qty",qty);if(!atc.disabled&&total)atc.textContent="Add to Cart \u2014 "+total;}
      if(buy){var id=atc?atc.getAttribute("data-pm-add"):null;if(id)buy.setAttribute("href","/cart/"+id+":"+qty);}
      if(stickyAtc)stickyAtc.setAttribute("data-pm-qty",qty);
      if(finalAtc){finalAtc.setAttribute("data-pm-qty",qty);if(!finalAtc.disabled&&total)finalAtc.textContent="Add to Cart \u2014 "+total;}
      if(stickyPrice&&total)stickyPrice.textContent=total;
    }
    opts.forEach(function(b){b.addEventListener("click",function(){apply(b);});});
    var def=box.querySelector("[data-pm-qpack].on")||opts[0];
    if(def)apply(def);
  });
})();
